import { RequestResponse } from '../../../../../core/application/http-response/http-response';
import {
  HttpClient,
  HttpMethod
} from '../../../../../core/application/protocols/http-client';
import { ServiceCommand } from '../../../../../core/domain/command/service-command';
import { error, success } from '../../../../../core/domain/either/either';
import { CompanyResponseModel } from '../../domain/models/companies/company-response-model';
import { OrganizationResponseModel } from '../../domain/models/organizations/organization-response-model';

export class SelfOnboarding implements ServiceCommand<SelfOnboarding.Response> {
  constructor(
    private readonly httpClient: HttpClient<SelfOnboarding.Response>,
    private readonly url: string
  ) {}

  async execute(
    params: SelfOnboarding.Params
  ): Promise<ServiceCommand.Response<SelfOnboarding.Response>> {
    const httpResponse = await this.httpClient.request({
      method: HttpMethod.POST,
      url: this.url,
      body: params
    });

    const responseOrError = RequestResponse.handle(httpResponse);

    if (responseOrError.isError()) {
      return error(responseOrError.value);
    }
    const response = responseOrError.value.response;

    return success(response);
  }
}

export namespace SelfOnboarding {
  export type Params = {
    cnpj: string;
    name: string;
    street: string;
    phone: string;
    email: string;
    userId: string;
  };

  export type Response = OrganizationResponseModel;
}
